import { omitBy } from "ramda-adjunct";

const removeKeysInArray = (array: string[]) => {
  const keyInArray = (val, key) => array.includes(key);

  return omitBy(keyInArray);
};

export default removeKeysInArray;
